export const breadcrumb = {
  title: 'Pemanggil Prediktif',
  trunk: {
    index: ''
  }
};
